import {
  applyMiddleware,
  createStore as createReduxStore,
  compose,
} from 'redux';
import thunk from 'redux-thunk';

import { rootReducer } from './reducers';

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export function createStore() {
  const middlewares = [thunk];
  const enhancers = [applyMiddleware(...middlewares)];
  const store = createReduxStore(rootReducer, composeEnhancers(...enhancers));
  return { store };
}
